import { createConcurrentCustomMetric } from '@confluence/browser-metrics/entry-points/metricConfigs';
import { LEGACY_EXTENSION_LOADING_CUSTOM_KEY } from '@confluence/browser-metrics/entry-points/metric-keys';

export const LEGACY_EXTENSION_LOADING_METRIC = createConcurrentCustomMetric({
	key: LEGACY_EXTENSION_LOADING_CUSTOM_KEY,
});
